import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

import { toast } from 'react-toastify';
import { Container } from '../../styles/GlobalStyles';
import SideBar from '../../components/SideBar';
import VisualizarProva from '../../components/VisualizarProva';
import axios from '../../services/axios';

export default function Prova({ match }) {
  const id = get(match, 'params.id', '');

  const [dados, setDados] = useState({});

  useEffect(() => {
    async function callQuestions() {
      try {
        const data = await axios(`/disciplina/${id}`);

        setDados(...[data.data]);
      } catch {
        toast.error('Não foi possível carregar a prova.');
      }
    }

    callQuestions();
  }, [id]);

  return (
    <VisualizarProva disciplina={dados} />
  );
}

Prova.propTypes = {
  match: PropTypes.shape({}).isRequired,
};
